import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
export var ParticlesDensity = /*#__PURE__*/function () {
  function ParticlesDensity() {
    _classCallCheck(this, ParticlesDensity);

    this.enable = false;
    this.width = 1920;
    this.height = 1080;
  }

  _createClass(ParticlesDensity, [{
    key: "area",
    get: function get() {
      return this.width;
    },
    set: function set(value) {
      this.width = value;
    }
  }, {
    key: "factor",
    get: function get() {
      return this.height;
    },
    set: function set(value) {
      this.height = value;
    }
  }, {
    key: "value_area",
    get: function get() {
      return this.area;
    },
    set: function set(value) {
      this.area = value;
    }
  }, {
    key: "load",
    value: function load(data) {
      var _ref, _data$width, _data$height;

      if (!data) {
        return;
      }

      if (data.enable !== undefined) {
        this.enable = data.enable;
      }

      var width = (_ref = (_data$width = data.width) !== null && _data$width !== void 0 ? _data$width : data.area) !== null && _ref !== void 0 ? _ref : data.value_area;

      if (width !== undefined) {
        this.width = width;
      }

      var height = (_data$height = data.height) !== null && _data$height !== void 0 ? _data$height : data.factor;

      if (height !== undefined) {
        this.height = height;
      }
    }
  }]);

  return ParticlesDensity;
}();